import React from 'react';
import { DocumentDragDropWrapper } from './ExceptionWaiveAttachments/DocumentDragDropWrapper';

export const ExceptionWaiveAttachmentWrapper = props => {
  const submitFailedAttachment = async attachment => {};
  return (
    <>
      <DocumentDragDropWrapper
        submitFailedAttachment={submitFailedAttachment}
        disableUpload={false}
        isChanged={props.isChanged}
      />
    </>
  );
};
